<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <VeeForm @submit="onSubmit" ref="userFieldForm">
        <modal-form
          v-model="isModalVisible"
          @on-cancel="() => (isModalVisible = false)"
          :title="isEditMode ? `Update ${crudName}` : `Add New ${crudName}`"
          width="40%"
        >
          <template #bodyForm>
            <dynamic-form :schema="formSchema" :formData="formData" />
          </template>
        </modal-form>
      </VeeForm>

      <dynamic-table
        :title="`${crudName}s`"
        :buttonTitle="`New ${crudName}`"
        :pageSize="pageSize"
        :pageNumber="pageNumber"
        :records="records?.data?.data || []"
        :totalRecords="records?.data?.totalRecords || 0"
        :columnDefs="userFieldColumns"
        :config="{
          allowEdit: [true, `Edit ${crudName}`],
          allowDelete: [false, `Delete ${crudName}`],
        }"
        @open-modal="handleNewUserField"
        @on-change-select="
          (value) => {
            pageNumber = 1;
            pageSize = value;
            getUserFields();
          }
        "
        @on-change-page="
          (value) => {
            pageNumber = value;
            getUserFields();
          }
        "
        @on-edit-record="handleEdit"
      >
        <template #headerTable> </template>
      </dynamic-table>
    </div>
  </div>
</template>

<script>
import { Form as VeeForm } from "vee-validate";
import { defineComponent, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";

import DynamicForm from "@/components/DynamicForm.vue";
import DynamicTable from "@/components/DynamicTable.vue";
import ModalForm from "@/components/ModalForm.vue";
import { userFieldForm as formSchema } from "@/constants/formSchemes";
import { userFieldColumns } from "@/constants/tableColumns";

import { showAlert } from "@/utils/alerts";

export default defineComponent({
  name: "UserFields",
  components: {
    VeeForm,
    ModalForm,
    DynamicForm,
    DynamicTable,
  },

  setup() {
    //config variables
    const store = useStore();
    const crudName = "User Field";

    //mode variables
    const isModalVisible = ref(false);
    const isEditMode = ref(false);

    //filter variables
    const pageSize = ref(10);
    const pageNumber = ref(1);
    const filter = ref("");

    const formData = ref({
      id: 0,
      name: "",
      description: "",
    });
    //computed variables
    const records = computed(() => store.state.fields.userFieldsResponse);

    //life cicle
    onMounted(() => {
      getUserFields();
    });

    const onSubmit = async (values, { resetForm }) => {
      isModalVisible.value = false;
      resetForm();
      const action = isEditMode.value ? "updateUserField" : "addUserField";
      const payload = isEditMode.value
        ? { ...values, id: formData.value.id }
        : values;

      await store.dispatch(`fields/${action}`, payload);

      if (store.getters["fields/isTransactionSuccess"]) {
        isEditMode.value
          ? showAlert(
              "Resource has been updated",
              "You can see the resource updated in the list",
              "success",
            )
          : showAlert(
              "Resource has been created",
              "You can see the resource in the list",
              "success",
            );
        await getUserFields();
      }
    };

    const handleEdit = (item) => {
      console.log(item.name);
      item.isActive = true;
      isModalVisible.value = true;
      isEditMode.value = true;
      Object.assign(formData.value, item);
    };

    const getUserFields = async () => {
      let params = `?pageSize=${pageSize.value}`;
      params += `&pageNumber=${pageNumber.value}`;
      if (filter.value != "")
        params += `&filter=x.name.contains("${filter.value}") or x.description.contains("${filter.value}")`;
      await store.dispatch("fields/getUserFields", params);
    };

    const handleNewUserField = () => {
      isModalVisible.value = true;
      isEditMode.value = false;
    };

    return {
      getUserFields,

      isModalVisible,
      isEditMode,
      crudName,

      //Filter variables
      pageNumber,
      pageSize,
      filter,

      formSchema,
      formData,
      userFieldColumns,
      records,
      onSubmit,
      handleEdit,
      handleNewUserField,
    };
  },
});
</script>
